import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import useDailyPlanCalendar from "./useDailyPlanCalendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-loading-skeleton/dist/skeleton.css";
import AssignWoModal from "./modal/AssignWOModal";
import EditWOModal from "./modal/EditWoModal";
import LoadingCalendar from "./LoadingCalendar";
import ErrorCalendar from "./ErrorCalendar";
import CustomCell from "./CustomCell";
import DeleteDPModal from "./modal/DeleteDPModal";

const localizer = momentLocalizer(moment);

const DailyPlanCalendar = ({ machine_id, wip, activeAccordion }) => {
    // Review - Vaishnavi - 22/01/2025 - Please add comments in complex structure
    // importing states and function from useDailyPlanCalendar custom hook
    const {
        machine,
        woEvents,
        currentWO,
        handleSelectEvent,
        handleSelectSlot,
        dailyPlanData,
        handleWOSelect,
        handleWOEdit,
        handleWORemove,
        setCurrentDate,
        loadingMachineInfoData,
        loadingWorkOrdersData,
        errorLoadingWorkOrders,
        errorLoadingMachineInfo,
        currentSlot,
        fetchingDailyPlan,
        fetchingMachineData,
        creatingDailyPlans,
        deletingDailyPlan,
    } = useDailyPlanCalendar({
        machine_id: machine_id,
        wip: { wip },
        activeAccordion: activeAccordion,
    });
    if (loadingMachineInfoData || loadingWorkOrdersData)
        return <LoadingCalendar />;
    if (errorLoadingMachineInfo || errorLoadingWorkOrders)
        // Review - vaishnavi - 22/01/2025 - We can call here Error Page rather than creating a new Error Page.
        return <ErrorCalendar />;
    return (
        <div className="h-100 position-relative">
            <Calendar
                localizer={localizer}
                defaultView="month"
                views={["month"]}
                events={woEvents}
                onSelectEvent={handleSelectEvent}
                onSelectSlot={handleSelectSlot}
                dayPropGetter={(date) => {
                    if (
                        new Date(date).setHours(0, 0, 0, 0) <
                        new Date().setHours(0, 0, 0, 0)
                    ) {
                        return {
                            style: {
                                backgroundColor: "#e6e6e6",
                                cursor: "not-allowed",
                            },
                        };
                    }
                    return {};
                }}
                onNavigate={(date) => setCurrentDate(date)}
                style={{
                    pointerEvents:
                        (fetchingMachineData ||
                            creatingDailyPlans ||
                            deletingDailyPlan) &&
                        "none",
                    opacity:
                        (fetchingMachineData ||
                            creatingDailyPlans ||
                            deletingDailyPlan) &&
                        0.5,
                }}
                components={{
                    month: {
                        dateHeader: (props) => (
                            <CustomCell {...props} shifts={machine?.shifts} />
                        ),
                    },
                }}
                selectable
                popup
            />
            <AssignWoModal
                currentSlot={currentSlot}
                machine_id={machine_id}
                handleWOSelect={handleWOSelect}
                activeAccordion={activeAccordion}
                dailyPlanData={dailyPlanData}
                isLoading={fetchingDailyPlan || loadingWorkOrdersData}
            />
            <EditWOModal
                machine_id={machine_id}
                handleWOEdit={handleWOEdit}
                handleWORemove={handleWORemove}
                dailyPlanData={dailyPlanData}
                currentWO={currentWO}
            />
            <DeleteDPModal
                machine_id={machine_id}
                handleWORemove={handleWORemove}
            />
            {fetchingMachineData || creatingDailyPlans || deletingDailyPlan ? (
                <div className="position-absolute top-0 h-100 w-100 right-10 d-flex align-items-center justify-content-center z-3">
                    <div
                        className="spinner-border text-primary ms-2"
                        role="status"
                    >
                        <span className="sr-only"></span>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default DailyPlanCalendar;
